import { render, staticRenderFns } from "./UpdateOrderStatusBtn.vue?vue&type=template&id=06fb6b51&scoped=true&"
import script from "./UpdateOrderStatusBtn.vue?vue&type=script&lang=js&"
export * from "./UpdateOrderStatusBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fb6b51",
  null
  
)

export default component.exports